<template>
  <div>
    <h5 class="info-text">Was soll gemacht werden?</h5>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox
              v-model="model.verfahrenArt1"
              icon="fas fa-pencil-alt"
              title="Heckenpflege"
            >
            </icon-checkbox>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox
              v-model="model.verfahrenArt2"
              icon="fas fa-terminal"
              title="Neuanlegung"
            >
            </icon-checkbox>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <icon-checkbox
              v-model="model.verfahrenArt3"
              icon="fas fa-laptop"
              title="Umwidmung einer Hecke"
            >
            </icon-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components";

export default {
  components: {
    IconCheckbox
  },
  data() {
    return {
      model: {
        verfahrenArt1: true,
        verfahrenArt2: false,
        verfahrenArt3: false,
      }
    };
  },
  methods: {
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    }
  }
};
</script>
<style></style>
